import { createContext } from 'react'

import type { CartContextType } from '@/src/domains/cart/types'

export const CartContext = createContext<CartContextType>(undefined as unknown as CartContextType)
